export default {
    format: function (price, hideDecimalNulls) {

		if (price === '') {
			return '';
		}

        let i, j, kw, kd, km, decPart;
        let decimals = 2;
        let dec_point = ",";
        let thousands_sep = " ";
        if (hideDecimalNulls === undefined) {
            hideDecimalNulls = true;
        }

        i = parseInt(price = (+price || 0).toFixed(decimals)) + "";

        if ((j = i.length) > 3) {
            j = j % 3;
        } else {
            j = 0;
        }

        km = (j ? i.substr(0, j) + thousands_sep : "");
        kw = i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands_sep);
        decPart = Math.abs(price - i).toFixed(decimals).replace(/-/, 0).slice(2);
        kd = (decimals ? dec_point + decPart : "");

        if (hideDecimalNulls && decPart === '00') {
            kd = '';
        }

        return km + kw + kd;
    }
}